import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=4b9f3afb&scoped=true&"
import script from "./ServiceView.vue?vue&type=script&lang=js&"
export * from "./ServiceView.vue?vue&type=script&lang=js&"
import style0 from "./ServiceView.vue?vue&type=style&index=0&id=4b9f3afb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f3afb",
  null
  
)

export default component.exports